export const priceBreakdown = {
  basePrice: "Base Price",
  codCharge: "COD Charges",
  dph: "DPH",
  totalCharge: "Total Charge",
  gstPercent: "GST",
  gstCharge: "GST",
  fuel_surcharge: "Fuel Surcharge",
  additional_fuel_surcharge: "Additional Fuel Surcharge",
  reverse_base: "Reverse Base Price",
  reverse_final_with_gst: "Reverse Total Charge",
  reverse_gst: "Reverse GST",
  opaCharge: "OPA Charge",
  odaCharge: "ODA Charge"
};
